export const gESConnectorStrs =
{
    "bamboo1": "Configurar la Conexión BambooHR",
    "bamboo2": "Subdominio",
    "bamboo3": "Clave API:",
    "bamboo3a": "Generar en su perfil BambooHR",
    "bamboo4": "ID de Reporte:",
    "bamboo4a": "Ingrese 0 para básico, 1 para extendido",
    "bamboo5": "Incluir empleados despedidos",
    "bambooloaderr": "Error en la consulta. Comprobar la configuración del conector BambooHR.",
    "bamboocerr1": "El subdominio no puede estar vacío.",
    "bamboocerr2": "ID Reporte no puede estar vacío.",
    "bamboocerr3": "Clave API debe tener exactamente 40 carácteres.",
    "bambookey": "Recuperar clave API",
    "peopleHR1": "Configurar conexión PeopleHR",
    "peopleHR2": "Clave API",
    "peopleHR3": "Generar en PeopleHR",
    "peopleHR4": "ID de Reporte:",
    "peopleHR4a": "Ingrese 0 para básico, 1 para extendido",
    "peoplehrcerr1": "Clave API no puede estar vacío.",
    "peoplehrcerr2": "ID de Reporte no puede estar vacío.",
    "peoplehrloaderr": "Error en la Consulta. Comprobar la configuración del conector PeopleHR.",
    "peoplehrloaderr2": "Error en la Autentificación. Comprobar configuración del conector PeopleHR.",
    "peoplehrloaderr3": "Datos erróneos devueltos. Comprobar configuración del conector PeopleHR.",
    "peoplehrloaderr4": "No existen registros de empleados devueltos",
    "adpHR1": "Configurar conexión ADP",
    "Client ID:": "ID del Cliente:",
    "adpHR2a": "Hacer clic en el botón Recuperar Claves",
    "Client Secret:": "Cliente Secreto:",
    "adpHR4": "Hacer clic en el botón Recuperar Claves",
    "adpHR5": "Campos Personaliz.:",
    "adpHR5a": "Hacer Clic sobre ? para más información",
    "adpHR6": "ID de Reporte:",
    "adpHR6a": "Ingrese 0 para básico, 1 para extendido",
    "adpHR10": "Consulta:",
    "adpHR10a": "Dejar vacío para consulta por defecto",
    "adpHR7": "Interface:",
    "adpHR8": "Incluir Campos Personalizados",
    "adpHR9": "Servidor Optimizado",
    "adpHR11": "Incluir campo foto",
    "adpkey": "Recuperar Claves",
    "adphrcerr1": "ID del Cliente no puede estar vacío.",
    "adphrcerr2": "Cliente Secreto no puede estar vacío.",
    "adphrcerr3": "ID de Reporte no puede estar vacío.",
    "adphrloaderr": "Error en la Consulta. Comprobar la configuración del conector ADP. Hacer clic en ? para detalles sobre la configuración del conector.",
    "adphrloaderr2": "Error en la Autentificación. Comprobar la configuración del conector ADP.",
    "adphrloaderr3": "Datos erróneos devueltos. Comprobar la configuración del conector ADP.",
    "adphrloaderr4": "No existen registros de empleados devueltos.",
    "adphrloaderr5": "Error en la Interface ADP:",
    "adphrloaderr6": "Error No Especificado",
    "adpkeymsg": "¡Claves ADP recuperadas! Ahora puede usar el asistente de importación para crear organigramas automáticamente usando su información de ADP.",
    "adpkeyhelpmsg": "Hacer clic en '?' para ayuda adicional.",
    "adpkeyfail_nooid": "Falta ID de Organización. Debe registrarse en ADP Marketplace para recuperar claves.",
    "adpkeyfail_auth": "Error Interno. Contacte soporte técnico.",
    "adpkeyfail_keyretrieve": "Error Interno - No se ha podido recuperar la clave. Contacte soporte técnico.",
    "subscribeHRConfig": "Configurar conexión Subscribe-HR",
    "subscribeHRLink2": "Estándar o personalizado",
    "subscribeHRUser1": "ID de Usuario:",
    "subscribeHRUser2": "ID de Usuario Subscribe-HR",
    "subscribeHRPass1": "Contraseña:",
    "subscribeHRReport1": "ID de Reporte:",
    "subscribeHRReport2": "Ingrese 0 para básico, 1 para extendido",
    "subscribehrcerr2": "ID del Usuario no puede estar vacío.",
    "subscribehrcerr3": "Contraseña no puede estar vacío.",
    "subscribehrcerr4": "ID de Reporte no puede estar vacío.",
    "subscribehrloaderr": "Consulta Fallida. Comprobar la conexión del conector Subscribe-HR.",
    "subscribehrloaderr2": "Autenticación fallida. Comprobar la conexión del conector Subscribe-HR.",
    "subscribehrloaderr3": "Datos erróneos devueltos. Comprobar la conexión del conector Subscribe-HR.",
    "subscribehrloaderr4": "No existen registros de empleados devueltos.",
    "ultiproConfig": "Configurar la conexión UKG Pro",
    "ultiproLink1": "Servidor",
    "ultiproLink2": "Recuperar de UKG Pro",
    "ultiproUser1": "Nombre de Usuario:",
    "ultiproUser2": "Nombre de usuario de UKG Pro",
    "ultiproPass1": "Contraseña:",
    "ultiproReport1": "ID de Reporte:",
    "ultiproReport2": "Ingrese 0 para básico, 1 para extendido",
    "upuseraccesskey1": "Clave de acceso de usuario",
    "upuseraccesskey2": "Recuperar de UKG Pro",
    "upclientaccesskey1": "Clave de acceso de cliente",
    "upclientaccesskey2": "Recuperar de UKG Pro",
    "ultiprocerr1": "El vínculo del Servidor no puede estar vacío.",
    "ultiprocerr2": "La Clave de Acceso del Usuario no puede estar vacía.",
    "ultiprocerr3": "La Clave de Acceso del Cliente no puede estar vacía.",
    "ultiprocerr4": "Nombre de Usuario no puede estar vacío.",
    "ultiprocerr5": "Contraseña no puede estar vacío.",
    "ultiprocerr6": "ID de Reporte no puede estar vacío.",
    "ultiprocerr7": "La interface debe de configurar para BI, BIT o WS.",
    "ultiprocerr8": "Nombre de Reporte no puede estar vacío.",
    "ultiprocerr9": "Ruta de Reporte no puede estar vacío.",
    "ultiproloaderr": "La consulta ha fallado. Compruebe la configuración del conector UKG Pro.",
    "ultiproloaderr2": "Error en la autenticación. Compruebe la configuración del conector UKG Pro.",
    "ultiproloaderr3": "Se han devuelto datos erróneos. Compruebe la configuración del conector UKG Pro.",
    "ultiproloaderr4": "No existen registros de empleados devueltos.",
    "ultiproInterface1": "Interfaz",
    "ultiproInterface2": "Ingresar BI, BIT o WS",
    "ultiproReportName1": "Nombre de Reporte:",
    "ultiproReportName2": "Sólo para interface BI",
    "ultiproReportPath1": "Ruta de Reporte:",
    "ultiproReportPath2": "Solo para interface BI(ej: Company_ACME_MyReports)",
    "ultiquery": "Ejecutar reporte como consulta",
    "odbcConfig": "Configurar Conexión ODBC",
    "odbcdsn": "DSN:",
    "odbcdsn2": "ODBC DSN",
    "odbcserver": "Servidor:",
    "odbcserver2": "Dirección del Servidor",
    "odbcdatabase": "Base de Datos:",
    "odbcdatabase2": "Nombre de Base de Datos (opcional)",
    "odbcuser": "ID del Usuario:",
    "odbcuser2": "ID del Usuario",
    "odbcpw": "Contraseña:",
    "odbctable": "Tabla/Vista:",
    "odbctable2": "Ingresar nombre de Tabla o Vista",
    "odbcdriver": "Unidad:",
    "odbcdriver2": "Ingresar nombre de la unidad(opcional)",
    "odbcreportid": "ID de Reporte:",
    "odbcreportid2": "Clic en 0 para estándar",
    "odbccerr1": "DSN no puede estar vacío.",
    "odbccerr2": "Servidor no puede estar vacío.",
    "odbccerr3": "Nombre de Usuario no puede estar vacío.",
    "odbccerr4": "Contraseña no puede estar vacía.",
    "odbccerr5": "Nombre de Tabla/Vista no puede estar vacía.",
    "odbccerr6": "ID de Reporte no puede estar vacío.",
    "odbcloaderr": "Consulta fallida. Comprobar configuración ODBC.",
    "sutihrcerr1": "Subdominio no puede estar vacío.",
    "sutihrcerr2": "Clave API no puede estar vacío.",
    "sutihrcerr3": "Nombre de Usuario no puede estar vacío.",
    "sutihrcerr4": "Contraseña no puede estar vacío.",
    "sutihrcerr5": "ID de Reporte no puede estar vacío.",
    "sutihrloaderr": "Consulta fallida. Comprobar la configuración del conector SutiHR.",
    "sutihrloaderr2": "Datos erróneos devueltos. Comprobar la configuración del conector.",
    "sutihrloaderr3": "No existen registros de empleados devueltos.",
    "suticonfig": "Configurar conexión SutiHR",
    "sutisub1": "Subdominio:",
    "sutiapi1": "Clave API:",
    "sutiapi2": "Generar en SutiHR",
    "sutiuserl": "Usuario SutiHR:",
    "sutiuser2": "ID del Usuario",
    "sutipw": "Contraseña:",
    "sutirid1": "ID de Reporte:",
    "sutirid2": "Tecla 0 para básico, 1 para ampliar",
    "salesforcecerr1": "ID de Usuario no puede estar vacío.",
    "salesforcecerr2": "Contraseña no puede estar vacía.",
    "salesforcecerr3": "Token de Seguridad no puede estar vacío.",
    "salesforcecerr4": "Valor de Sandbox inválido.",
    "salesforcecerr5": "Consulta no puede estar vacía.",
    "salesforcecerr6": "Asignación de Campo no puede estar vacío.",
    "salesforceloaderr": "Consulta fallida. Comprobar la conexión del conector Salesforce.",
    "salesforceloaderr2": "Datos Erróneos devueltos. Comprobar la configuración del conector.",
    "salesforceloaderr3": "Ningún Archivo regresado.",
    "salesforceConfig": "Configurar conexión Salesforce",
    "sfuser": "ID del Usuario",
    "sfuser2": "ID del Usuario Salesforce",
    "sfpassword": "Contraseña",
    "sfpassword2": "Contraseña de Salesforce",
    "sftoken": "Token de Seguridad",
    "sftoken2": "Token de seguridad de Salesforce",
    "sfsandbox": "Sandbox",
    "sfsandbox2": "Dejar en blanco para producción, establecer en ’verdadero’ para sandbox",
    "sfquery": "Consulta",
    "sfquery2": "Consulta Salesforce SOQL",
    "sffieldmap": "Asignación de Campo",
    "sffieldmap2": "Lista delimitada por comas para nombres de los campos deseados",
    "sfsfConfig": "Configurar conexión de SuccessFactors",
    "sfsfservice": "Servidor",
    "sfsfservice2": "Dirección del Servidor SuccessFactors (Ejemplo: api4)",
    "sfsfuser": "Identificación de Usuario",
    "sfsfuser2": "ID del Usuario SuccessFactors",
    "sfsfpassword": "Contraseña",
    "sfsfpassword2": "Contraseña de SuccessFactors",
    "sfsforg": "Código de organización",
    "sfsforg2": "Código de Organización SuccessFactors",
    "sfsfadd": "Campos Adicionales:",
    "sfsfadd2": "Especifique campos adicionales para agregar a la consulta",
    "sfsfreportid": "ID de Reporte:",
    "sfsfreportid2": "Ingrese 0 para básico, 1 para extendido",
    "sfsfcerr0": "Dirección del Servidor no puede estar vacía.",
    "sfsfcerr1": "ID del Usuario no puede estar vacío.",
    "sfsfcerr2": "Contraseña no puede estar vacía.",
    "sfsfcerr3": "Código de Org no puede estar vacío.",
    "sfsfcerr4": "ID de Reporte no puede estar vacío.",
    "sfsfloaderr": "Consulta Fallida. Comprobar la configuración del conector SuccessFactors .",
    "triConfig": "Configurar Conexión TriNet",
    "tricompany2": "Nombre de Compañía",
    "triuser": "ID del Usuario:",
    "triuser2": "ID del Usuario TriNet",
    "tripassword": "Contraseña:",
    "tripassword2": "Contraseña TriNet",
    "triclientid": "ID del Cliente:",
    "triclientid2": "ID del Cliente TriNet",
    "triclientsecret": "Cliente Secreto:",
    "triclientsecret2": "Cliente Secreto TriNet",
    "trireportid": "ID de Reporte:",
    "trireportid2": "Ingrese 0 para básico, 1 para extendido",
    "tricerr1": "ID del Usuario no puede estar vacío.",
    "tricerr2": "Contraseña no puede estar vacío.",
    "tricerr3": "ID del Cliente no puede estar vacío.",
    "tricerr4": "Cliente Secreto no puede estar vacío.",
    "tricerr5": "ID de Reporte no puede estar vacío.",
    "triloaderr": "Consulta fallida. Comprobar la configuración del conector TriNet .",
    "orangeConfig": "Configurar Conexión OrangeHRM",
    "orangesubdomain": "Subdominio:",
    "orangesubdomain2": "subdomain.orangehrm.com",
    "orangeuser": "ID del Usuario:",
    "orangeuser2": "ID del Usuario OrangeHRM",
    "orangepassword": "Contraseña:",
    "orangepassword2": "Contraseña OrangeHRM",
    "reportID": "ID de Reporte:",
    "orangereportid2": "Ingrese 0 para básico, 1 para extendido",
    "orangecerr0": "Subdominio no puede estar vacío.",
    "orangecerr1": "ID del Usuario no puede estar vacío.",
    "orangecerr2": "Contraseña no puede estar vacío.",
    "orangecerr3": "ID de Reporte no puede estar vacío.",
    "orangeloaderr": "Consulta fallida. Comprobar la conexión del conector OrangeHRM .",
    "sapxmlConfig": "Configurar Conexión SAP XML",
    "sapxmlfields": "Campos Adicionales:",
    "sapxmlfields2": "Ingresar Campos Adicionales para Consulta",
    "sapConfig": "Configurar Conexión SAP RFC",
    "saphost": "Solicitud del Servidor:",
    "saphost2": "Ingrese Dirección del Host",
    "sapclient": "Cliente:",
    "sapclient2": "Ingresar Número del Cliente",
    "sapsystem": "Número del Sistema:",
    "sapsystem2": "Ingresar Número del Sistema",
    "sapuser": "Usuario SAP:",
    "sapuser2": "Ingresa nombre de Usuario SAP",
    "sappassword": "Contraseña SAP:",
    "sappassword2": "Ingresa Contraseña SAP",
    "sapviewid": "Vista del ID:",
    "sapviewid2": "Ingrese ViewID",
    "sapobjectid": "ID del Objeto:",
    "sapobjectid2": "Ingresar ID del Objeto",
    "sapobjecttype": "Tipo de Objeto:",
    "sapobjecttype2": "Ingresa Tipo de Objeto",
    "sapparams": "Campos Adicionales:",
    "sapparams2": "Ingresa los Campos Adicionales para Consulta",
    "sapcerr0": "Solicitud del Servidor no puede estar vacío.",
    "sapcerr1": "Número del Cliente no puede estar vacío.",
    "sapcerr2": "Número del Sistema no puede estar vacío.",
    "sapcerr3": "Usuario SAP no puede estar vacío.",
    "sapcerr4": "Contraseña SAP no puede estar vacía.",
    "sapcerr5": "Vista del ID no puede estar vacía.",
    "sapcerr6": "Objeto del ID no puede estar vacío.",
    "sapcerr7": "Tipo de Objeto no puede estar vacío.",
    "saploaderr": "Consulta fallida. Consultar la configuración del conector SAP.",
    "payspaceConfig": "Configurar la Conexión de la Nube",
    "payspacecompanycode": "Código de la Compañía:",
    "payspacecompanycode2": "Ingresar Codigo de la Compañía",
    "payspaceuser": "ID del Usuario:",
    "payspaceuser2": "ID del Usuario",
    "payspacepassword": "Contraseña:",
    "payspacepassword2": "Contraseña",
    "payspacereqtype": "Tipo de Solicitud:",
    "payspacereqtype2": "EmpDir, JobDir o tipo personalizado",
    "payspaceterm": "Meses de Término:",
    "payspaceoptions": "Opciones:",
    "payspaceterm2": "Ingrese 0 para excluir empleados despedidos",
    "payspacereportid": "ID de Reporte:",
    "payspacereportid2": "Ingrese 0 para básico, 1 para extendido",
    "payspacecerr0": "Código de la Compañía no puede estar vacío.",
    "payspacecerr1": "ID del Usuario no puede estar vacío.",
    "payspacecerr2": "Contraseña no puede estar vacía.",
    "payspacecerr3": "Tipo de Solicitud no puede estar vacío.",
    "payspacecerr4": "Meses de Terminación no puede estar vacío.",
    "payspacecerr5": "ID de Reporte no puede estar vacío",
    "payspaceloaderr": "Consulta fallida. Comprobar configuración del conector.",
    "googleConfig": "Configurar conexión del Directorio Google",
    "googleDomain": "Nombre de Dominio:",
    "googleDomain2": "mycompany.com",
    "googleemail": "Email:",
    "googleemail2": "Cuenta del email Autorizado",
    "googlereportid": "ID de Reporte:",
    "googlereportid2": "Ingrese 0 para básico, 1 para extendido",
    "googlecerr0": "Dominio no puede estar vacío.",
    "googlecerr3": "ID de Reporte no puede estar vacío.",
    "googleloaderr": "Consulta Fallida. Comprobar la configuración del conector Google.",
    "googlecredupload": "Credenciales Cargadas.",
    "googlecreduploadfail": "Carga fallida - Contacte a Soporte.",
    "googleserv1": "Cargar credenciales de cuenta de servicio",
    "googledirloaderr": "Consulta fallida. Comprobar la configuración del conector de Directorio Google.",
    "breatheHR1": "Configurar Conexión breatheHR",
    "breatheHR2": "Clave API",
    "breatheHR3": "Generar en breatheHR",
    "breatheHR4": "ID de Reporte",
    "breatheHR4a": "Ingrese 0 para básico, 1 para extendido",
    "breathehrcerr1": "Clave API no puede estar vacío .",
    "breathehrcerr2": "ID de Reporte no puede estar vacío.",
    "breathehrloaderr": "Consulta fallida. Comprobar la configuración del conector breatheHR .",
    "breathehrloaderr2": "Autenticación fallida. Comprobar la configuración del conector breatheHR .",
    "breathehrloaderr3": "Datos erróneos devueltos. Comprobar la configuración del conector breatheHR .",
    "breathehrloaderr4": "No existen registros de empleados devueltos.",
    "activedirConfig": "Configurar Conexión del Directorio Activo",
    "activedirmsg": "Para poder extraer datos del Directorio Activo, un pequeño paquete de software debe ser instalado en un servidor dentro de su red. Haga clic en '?' para más información.",
    "authsuccess": "Prueba de Autenticación: Exitosa",
    "authfailure": "Prueba de Autenticación: Fallida",
    "uf_usertype_err": "Tipo de Usuario Inválido en userfeed.txt",
    "uf_filenotfound_err": "No se pudo encontrar o cargar el archivo userfeed",
    "uf_userexists_err": "Registro de Usuario en uso por otra cuenta.",
    "uf_badgroup_err": "Grupo de Acceso Invalido",
    "uf_invaliduser": "Usuario o correo electrónico inválido no se encontró en userfeed.txt",
    "uf_usernotfound": "El usuario actual no se encontró en userfeed.txt",
    "namelyConfig": "Config. Conexión Nombrada",
    "namelysubdomain": "Subdominio:",
    "namelysubdomain2": "subdominio.nombre.com",
    "namelytoken": "Token API:",
    "namelytoken2": "Generar en perfil Nombrado",
    "namelyreportid2": "Ingrese 0 para básico, 1 para fotos",
    "namelycerr0": "El subdominio no puede estar en blanco.",
    "namelycerr1": "El token API no puede estar en blanco.",
    "namelycerr2": "ID Reporte no puede estar en blanco.",
    "namelyloaderr": "Fallo en Consulta. Verifique configuración de conector Nombrado.",
    "customloaderr": "Consulta personalizada con fallo.",
    "dynloaderr1": "No se obtuvieron datos. Contacte soporte técnico. Código de Error DC01.",
    "dynloaderr2": "No se obtuvieron datos. Contacte soporte técnico. Código de Error DC02.",
    "dynloaderr3": "Fallo en Consulta. Contacte soporte técnico. Código de Error DC03.",
    "greenhouseConfig": "Configurar Conexión Greenhouse",
    "greenhousetoken": "Token API:",
    "greenhousetoken2": "Generar en su perfil Greenhouse",
    "greenhousereportid2": "Ingrese 0 para básico, 1 para extendido",
    "greenhousecerr0": "El token API no puede estar en blanco.",
    "greenhousecerr1": "ID de Reporte no puede estar en blanco.",
    "greenhouseloaderr": "Consulta fallida. Verifique la configuración del conector Greenhouse.",
    "greenhousev1label": "Usar la API v1 heredada (API Key)",
    "greenhouseconnect": "Conectar con Greenhouse",
    "greenhousereconnect": "Volver a conectar con Greenhouse",
    "greenhouseadminreq": "Inicie sesión como administrador del sitio de Greenhouse para autorizar.",
    "greenhouseautherr": "Error de autorización de Greenhouse. Intente conectarse de nuevo.",
    "bamboo6": "Campos Personalizados:",
    "bamboo6a": "Por favor haga clic en '?' para obtener más información.",
    "greenhousetitle": "Nombre Cargo:",
    "greenhousetitle2": "¿Con qué se asigna el cargo?",
    "greenhouseemail": "Email:",
    "greenhouseemail2": "¿Con qué se asigna el email?",
    "greenhousedept": "Departamento:",
    "greenhousedept2": "¿Con qué se asigna el departamento?",
    "greenhousecerr2": "El Email no puede estar vacío.",
    "greenhousecerr3": "El Departamento no puede estar vacío.",
    "greenhousecerr4": "ID Reporte no puede estar vacío.",
    "QATS": "Agregar Datos Greenhouse ATS",
    "azureConfig": "Configurar Conexión AzureAD",
    "azuremsg": "Por favor contacte soporte técnico para ayuda extrayendo datos de su instancia AzureAD.",
    "naturalhrConfig": "Configurar Conexión NaturalHR",
    "naturalhrtoken": "Token API:",
    "naturalhrtoken2": "Generar en su perfil NaturalHR",
    "naturalhrcerr1": "El token API no puede estar vacío.",
    "naturalhrcerr2": "El ID Informe no puede estar vacío.",
    "naturalhrloaderr": "Consulta fallida. Verifique la configuración del conector NaturalHR.",
    "workdayConfig": "Configurar Conexión Workday",
    "workdaymsg": "Por favor contacte soporte técnico para ayuda extrayendo datos de su cuenta Workday.",
    "jobviteConfig": "Configurar Conexión Jobvite",
    "jobvitekey": "Llave API:",
    "jobvitekey2": "Generar en su perfil Jobvite",
    "jobvitesecret": "API Secret:",
    "jobvitesecret2": "Generar en su perfil Jobvite",
    "jobvitetitle": "Puesto:",
    "jobvitetitle2": "¿Asignar puesto a?",
    "jobvitedept": "Departamento:",
    "jobvitedept2": "¿Asignar departamento a?",
    "reportid2": "Ingresar 0 para Estándar",
    "ATSType": "ATS:",
    "icimsConfig": "Configurar Conexión iCIMS",
    "icimsuser": "Usuario:",
    "icimsuser2": "Recibido de su especialista de integración iCIMS",
    "icimspwd": "Contraseña:",
    "icimspwd2": "Recibido de su especialista de integración iCIMS",
    "icimscusid": "ID Cliente:",
    "icimscusid2": "Su ID de Cliente iCIMS",
    "icimstitle": "Puesto:",
    "icimstitle2": "¿Asignar puesto a?",
    "icimsdept": "Departamento:",
    "icimsdept2": "¿Asignar departamento a?",
    "icimscerr0": "El Usuario no puede estar vacío.",
    "icimscerr2": "ID Cliente no puede estar vacío.",
    "icimscerr3": "Puesto no puede estar vacío.",
    "icimscerr1": "Contraseña no puede estar vacía.",
    "icimscerr4": "Token Departamento no puede estar vacío.",
    "icimscerr5": "ID Informe no puede estar vacío.",
    "jobvitecerr0": "Llave API no puede estar vacío.",
    "jobvitecerr2": "Puesto no puede estar vacío.",
    "jobvitecerr1": "API Secret no puede estar vacío.",
    "jobvitecerr3": "Token de Departamento no puede estar vacío.",
    "jobvitecerr4": "ID Informe no puede estar vacío.",
    "jobviteloaderr": "Consulta fallida. Verifique su configuración de conexión Jobvite.",
    "adpprofile": "Guardar Perfil",
    "ADPProf": "Perfil:",
    "notSandbox": "Esta no es una Cuenta Sandbox",
    "workdayapiuser": "Usuario API",
    "workdayapiuser2": "El usuario ha dado permiso para usar Workday",
    "workdaypassword": "Contraseñade la API",
    "workdaypassword2": "La contraseña de usuarios API",
    "workdaycerr0": "El usuario API no puede estar en blanco.",
    "workdaycerr1": "El Usuario Workday no puede estar en blanco",
    "workdaycerr2": "La contraseña no puede estar en blanco.",
    "workdaycerr4": "El token ReportID no puede estar en blanco.",
    "workdayendpoint2": "Ultimo punto del RaaS que usted genero",
    "custommsg": "Por favor contacte a soporte técnico para ayuda con la extracción de datos desde su instancia personalizada.",
    "sfsfquerystring": "Parámetros de Consulta",
    "signifycerr0": "El token no puede estar en blanco",
    "customConfig": "Configurar Conexión Personalizada",
    "sfsfresource": "Tabla de Recursos",
    "signifyconfig": "Configuración de Conexión a Signify",
    "signifytoken2": "El token API generado en Signify",
    "workdayendpoint": "Punto de conexión de Workday",
    "sfsfquerystring2": "Parámetros de Consulta",
    "Email Field": "Campo Email",
    "Hiring Manager": "Gerente de Contratación",
    "sftpport1": "Puerto",
    "sftpdirectory1": "Ruta de la fuente",
    "sftpport2": "Si está en blanco, valor por defecto es 22",
    "Custom Search": "Búsqueda personalizada",
    "leverreqs": "Todas las solicitudes",
    "sftpusername1": "Nombre de Usuario",
    "levertoken": "API Token:",
    "sftpfilename1": "Nombre de Archivo",
    "levertoken2": "Genera en su perfil de Lever",
    "sftphost2": "Ex: sftp://example.orgchartnow.com",
    "sftpusername2": "Ex: example_ex",
    "peopleHR5": "Nombre de la Consulta:",
    "peopleHR7": "Utilizar Consulta",
    "Inactive Statuses": "Estado de Inactividad",
    "peopleHR6": "Introduzca el nombre de la consulta hecha en PeopleHR",
    "sftppassword2": "Contraseña para su cuenta de SFTP.",
    "sftppassword1": "Contraseña",
    "sftpfilename2": "Ej.: Archivo de prueba.xls",
    "sftpdirectory2": "Ej.: Subdir1/Subdir 2/subdir3",
    "breatheHR5": "Empleados pasados",
    "sftphost1": "Alojamiento",
    "genericapisecret1": "API Secreto",
    "genericapikey1": "API Clave",
    "genericloaderr": "Error en la consulta. Compruebe la configuración del conector.",
    "genericcompanyid1": "ID de la empresa",
    "genericapisecret2": "Introduzca el secreto de la API",
    "genericadditionaltables": "Tablas adicionales",
    "genericclientid1": "ID de cliente",
    "clearcompanypassword2": "Introduzca la contraseña para ClearCompany ATS.",
    "genericpassword2": "Introduzca la contraseña de la API",
    "Leave blank to match subdomain": "Dejar en blanco para que coincida con el subdominio",
    "genericusername1": "Nombre de usuario",
    "genericclientid2": "Introduzca el ID de cliente de la API",
    "genericpassword1": "Contraseña",
    "genericclientsecret1": "Cliente Secreto",
    "genericusername2": "Introduzca el nombre de usuario de la API",
    "genericsubdomain2": "Introduzca el subdominio API",
    "genericcompanyid2": "Introduzca el ID de empresa API",
    "clearcompanyusername2": "Introduzca el nombre de usuario de ClearCompany ATS.",
    "genericapikey2": "Introduzca la clave API",
    "genericqueryparams": "Parámetros de consulta",
    "genericclientsecret2": "Introduzca API cliente secreto",
    "genericclientkey1": "Clave de cliente",
    "Photo URL": "URL de la foto",
    "genericsubdomain1": "Subdominio",
    "genericclientkey2": "Introduzca la clave de cliente API",
    "Separate Job Reqs": "Cuadros separados para cada requisición de puesto abierta",
    "Req Count Field1": "Campo Conteo Req",
    "Req Count Field2": "Ingrese el campo recuento de requisiciones de los datos ATS",
    "genericresource2": "Escribe recurso",
    "genericresource1": "Recurso",
    "generictenantid2": "Escribe la identificación del inquilino",
    "genericcompany2": "La empresa no puede estar en blanco",
    "genericapppass2": "Ingrese la contraseña de la aplicación",
    "genericappid1": "ID de aplicación",
    "genericsite1": "Sitio",
    "genericappid2": "Ingrese el ID de la aplicación",
    "genericdomain2": "Ingrese el dominio",
    "genericcompany1": "Empresa",
    "generictable": "Mesa",
    "genericdomain1": "Dominio",
    "generictenantid1": "ID de inquilino",
    "genericcommunity2": "Escribe comunidad",
    "genericcommunity1": "Comunidad",
    "genericapppass1": "Contraseña de la aplicación",
    "genericsite2": "Escribe sitio",
    "generictoken2": "Ingrese el token de la API",
    "dfstatus2": "Códigos de estado activo (opcional)",
    "genericusetable": "Usar Tabla",
    "genericendpoint1": "Punto final de la API",
    "generictoken1": "Token de la API",
    "genericendpoint2": "Ingresa punto final de la API",
    "genericport1": "Número de puerto",
    "genericport2": "Ingresa Número de puerto",
    "dfstatus1": "Estados activos",
    "dfidprefix": "Prefijo de ID de empleado",
    "dfidprefixhelper": "Se añade a los ID de empleado y de responsable de esta fuente. Utilícelo cuando dos entornos de Dayforce reutilicen los mismos números de empleado.",
    "payspacetogglerest": "Utilizar la API REST",
    "sageauthmethodtoggle": "Utilizar la autenticación con nombre de usuario y contraseña",
    "ATS": "ATS",
    "genericrefreshtoken2": "Ingrese el token de actualización de la API",
    "genericaccountname1": "Nombre de cuenta",
    "genericadditionalfields1": "Campos adicionales",
    "Child resources helper": "workRelationships.assignments, names",
    "genericaccountname2": "Ingrese el nombre de la cuenta",
    "genericrefreshtoken1": "Token de actualización",
    "peopleHR8": "Consulta todos los campos (incluye datos sensibles)",
    "Finder helper": "Consulta usando un buscador predefinido (por ejemplo, 'findByPersonId')",
    "limitlabel": "Registros por solicitud",
    "limithelper": "Número de registros a obtener por llamada a la API (predeterminado 250, máximo 500)",
    "genericadditionalfields2": "Ingrese campos adicionales",
    "bambootogglelegacy": "Utilizar (Legacy) API Key",
    "Parameters": "Parámetros",
    "Custom Base Profile": "Perfil Base Personalizado",
    "Parameters helper": "Parámetro de consulta (por ejemplo, 'workRelationships.TerminationDate is null')",
    "genericclientcode1": "Código de cliente",
    "genericfilter2": "Ingresar filtro",
    "genericfilter1": "Filtro",
    "genericclientcode2": "Ingresar código de cliente",
    "genericschemaid1": "ID de esquema",
    "genericschemaid2": "Ingresar ID de esquema",
    "Child resources": "Recursos secundarios",
    "adpoid": "ADP OID",
    "Finder": "Finder",
    "genericstatus1": "Estados",
    "paycorsubkey1": "Clave de suscripción",
    "paycorsubkey2": "Ingrese la clave de suscripción de Paycor",
    "paycorlegentityid1": "ID de entidad legal",
    "paycorlegentityid2": "Ingrese el ID de entidad legal de Paycor",
    "othLoginUrl": "eywpLoginUrl",
    "PaycomIP": "Contacte a su administrador de Paycom para agregar la siguiente dirección IP a la lista de permitidos",
    "PaycomHelp": "Paycom requiere que agregue a la lista de permitidos todas las direcciones IP desde las que planea acceder a la API",
    "Source ID": "ID de origen",
    "Generating...": "Generando...",
    "Loading...": "Cargando...",
    "Loading existing key...": "Cargando clave existente...",
    "Regenerate API Key": "Regenerar clave API",
    "Generate API Key": "Generar clave API",
    "API key configured": "Clave API configurada",
    "No API key generated": "No se ha generado una clave API",
    "API key generated successfully": "Clave API generada correctamente",
    "Failed to generate API key": "Error al generar la clave API",
    "View or regenerate the API key used for this integration. If you regenerate the key, remember to update it in your external application to maintain connectivity. ": "Consulte o regenere la clave API utilizada para esta integración. Si regenera la clave, recuerde actualizarla en su aplicación externa para mantener la conectividad. {linkText}",
    "Click here to find documentation.": "Haga clic aquí para ver la documentación.",
    "An error occurred. Please try again.": "Se produjo un error. Inténtelo de nuevo.",
    "resourceId": "ID de recurso",
    "resourceId2": "Ingrese el ID de recurso de Azure AD"
}
